// UPDATED for your actual HTML:
// Year/Make/Model selects are: #dropdown-field_1, #dropdown-field_2, #dropdown-field_3 (class .ymm-filter)
// Buttons are: #ymm_search, #ymm_reset
// Results container is: #products (and loader: .ymm-prd-loader)

var app_url_sema = "http://phpstack-789885-2892914.cloudwaysapps.com/"; // IMPORTANT: use https on Shopify
var shop_url_sema = Shopify.shop;

var resultload = true;
console.log("running sema.js (updated for YMM HTML)");

/* -------------------------
   Cookie helpers
------------------------- */
function createCookiesForSearchFilter(key, value, days = 1) {
  let expires = "";
  if (days) {
    const expiry = new Date();
    expiry.setTime(expiry.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + expiry.toUTCString();
  }
  document.cookie =
    encodeURIComponent(key) +
    "=" +
    encodeURIComponent(value) +
    expires +
    "; path=/";
}

function getCookieValue(cookieName) {
  const name = cookieName + "=";
  const decodedCookie = decodeURIComponent(document.cookie || "");
  const cookieArray = decodedCookie.split(";");

  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i].trim();
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length);
    }
  }
  return null;
}

/**
 * Sets a select's value based on cookie.
 * @param {string} selector CSS selector (e.g. '#dropdown-field_1')
 * @param {string} cookieKey cookie key to read
 */
function setSelectValueByCookie(selector, cookieKey) {
  const v = getCookieValue(cookieKey);
  if (v !== null) {
    $(selector).val(v);
  }
  return v ?? null;
}

/* -------------------------
   URL param helper
------------------------- */
function getUrlVars() {
  const vars = {};
  const qIndex = window.location.href.indexOf("?");
  if (qIndex === -1) return vars;

  const hashes = window.location.href.slice(qIndex + 1).split("&");
  for (let i = 0; i < hashes.length; i++) {
    const parts = hashes[i].split("=");
    const k = parts[0];
    const v = parts[1] ?? "";
    vars[k] = v;
  }
  return vars;
}

/* -------------------------
   Results fetch + render
------------------------- */
function showProductsLoading(isLoading) {
  const $loader = $(".ymm-prd-loader");
  if (!$loader.length) return;
  $loader.css("display", isLoading ? "block" : "none");
}

function get_ss_product(year, make, model, page) {
  // Normalize Shopify YMM values if needed (your selects look like: yr_2021, mk_bmw, md_330i)
  // If your backend expects raw values, adjust there or strip prefixes here.
  showProductsLoading(true);

  // Optional customer fields (only if present on page)
  const customerLogIn = $("#customer_logged_in").length
    ? $("#customer_logged_in").val()
    : "";
  const customerTags = $("#customer_tags").length ? $("#customer_tags").val() : "";
  console.log('posting data for return' + year + make + model);
  $.ajax({
    type: "POST",
    url: app_url_sema + "front/get_ss_product",
    data: {
      year: year,
      make: make,
      model: model,
      page: page,
      is_log_in: customerLogIn,
      customer_tag: customerTags,
      shop_domian: "https://hushmat.com", // leaving as-is since your backend uses it
      shop: shop_url_sema,
    },
    success: function (data) {
      // Your HTML uses #products as the results container
      console.log(data);
      $("#products").html(data);

      // Scroll to results area (your HTML wraps in #product_container)
      if ($("#product_container").length) {
        $([document.documentElement, document.body]).animate(
          { scrollTop: $("#product_container").offset().top },
          200
        );
      }
    },
    complete: function () {
      showProductsLoading(false);
    },
    error: function (xhr) {
      showProductsLoading(false);
      console.warn("get_ss_product error", xhr?.status, xhr?.responseText);
    },
  });
}

function call_ss_product() {
  console.log("getting product data");
  const year = $("#dropdown-field_1").val();
  const make = $("#dropdown-field_2").val();
  const model = $("#dropdown-field_3").val();
  get_ss_product(year, make, model, 0);
}

/* -------------------------
   Enable/disable search
------------------------- */
function search_enable() {
  // Your selects default to "-1" when not chosen
  const year = $("#dropdown-field_1").val();
  const make = $("#dropdown-field_2").val();

  const ok = year && year !== "-1" && make && make !== "-1";
  $("#ymm_search").prop("disabled", !ok);
}

/* -------------------------
   Hook up the YMM UI
------------------------- */
(function initYmmBindings() {
  // Only run on pages where YMM exists
  if (!$("#ymm_searchbox").length) return;

  // Restore from cookies (values must match option values e.g. yr_2021 / mk_bmw / md_330i)
  const cYear = setSelectValueByCookie("#dropdown-field_1", "ymm_year");
  if (cYear) {
    // If your make/model are populated dynamically in other pages, you might need async sequencing.
    // On this page they appear already populated, so we set them directly too:
    setSelectValueByCookie("#dropdown-field_2", "ymm_make");
    setSelectValueByCookie("#dropdown-field_3", "ymm_model");
  }

  // Also support URL params yr/mk/md if present (your script used these)
  // Note: your URL params should match actual option values (yr_2021, mk_bmw, md_330i)
  const vars = getUrlVars();
  if (typeof vars["yr"] !== "undefined" && resultload) {
    const qyr = decodeURIComponent(vars["yr"]);
    $("#dropdown-field_1").val(qyr);
  }
  if (typeof vars["mk"] !== "undefined" && resultload) {
    const qmk = decodeURIComponent(vars["mk"]);
    $("#dropdown-field_2").val(qmk);
  }
  if (typeof vars["md"] !== "undefined" && resultload) {
    const qmd = decodeURIComponent(vars["md"]);
    $("#dropdown-field_3").val(qmd);
  }

  // After setting from URL, trigger product load once (if yr & mk exist)
  search_enable();
  if (
    resultload &&
    $("#dropdown-field_1").val() &&
    $("#dropdown-field_1").val() !== "-1" &&
    $("#dropdown-field_2").val() &&
    $("#dropdown-field_2").val() !== "-1"
  ) {
    resultload = false;
    call_ss_product();
  }

  // Change handlers (save cookies + keep in sync)
  $("body").on("change", "#dropdown-field_1", function () {
    createCookiesForSearchFilter("ymm_year", $(this).val());
    search_enable();
    // OPTIONAL: If you want auto-fetch on change:
    // call_ss_product();
  });

  $("body").on("change", "#dropdown-field_2", function () {
    createCookiesForSearchFilter("ymm_make", $(this).val());
    search_enable();
    // OPTIONAL: call_ss_product();
  });

  $("body").on("change", "#dropdown-field_3", function () {
    createCookiesForSearchFilter("ymm_model", $(this).val());
  });

  // Reset
  $("body").on("click", "#ymm_reset", function (e) {
    e.preventDefault();
    $("#dropdown-field_1").val("-1");
    $("#dropdown-field_2").val("-1");
    $("#dropdown-field_3").val("-1");

    // Clear cookies (set empty)
    createCookiesForSearchFilter("ymm_year", "", 1);
    createCookiesForSearchFilter("ymm_make", "", 1);
    createCookiesForSearchFilter("ymm_model", "", 1);

    $("#products").empty();
    search_enable();
  });

  // Search (either redirect or load inline)
  // Your old code redirected to /pages/product-result; your current HTML *already is* the product result page.
  // So we fetch inline.
  $("body").on("click", "#ymm_search", function (e) {
    e.preventDefault();

    const year = $("#dropdown-field_1").val();
    const make = $("#dropdown-field_2").val();
    const model = $("#dropdown-field_3").val();

    if (!year || year === "-1" || !make || make === "-1") return;

    // If you still want URL params:
    // const rq = "yr=" + encodeURIComponent(year) + "&mk=" + encodeURIComponent(make) + "&md=" + encodeURIComponent(model || "");
    // location.href = "https://hushmat.com/pages/product-result?" + rq;

    // Inline fetch:
    call_ss_product();
  });

  // Pagination (you mentioned #ss_pre_page/#ss_next_page before; your HTML uses #paginate).
  // If your backend renders paging links with data-page attributes, this will work:
  $("body").on("click", "#paginate [data-page]", function (e) {
    e.preventDefault();
    const page = $(this).attr("data-page");
    const year = $("#dropdown-field_1").val();
    const make = $("#dropdown-field_2").val();
    const model = $("#dropdown-field_3").val();
    get_ss_product(year, make, model, page);
  });

  // Initial enable state
  search_enable();
})();

/* -------------------------
   Optional: selected vehicle display
------------------------- */
$(document).ready(function () {
  if ($("#selected_vehicle_info").length > 0) {
    const cookie_selected_year = getCookieValue("ymm_year");
    const cookie_selected_make = getCookieValue("ymm_make");
    const cookie_selected_model = getCookieValue("ymm_model");
    if (
      cookie_selected_year !== null &&
      cookie_selected_make !== null &&
      cookie_selected_model !== null
    ) {
      const selected_vehicle_info =
        "Your selected vehicle is: " +
        cookie_selected_year +
        " " +
        cookie_selected_make +
        " " +
        cookie_selected_model;
      $("#selected_vehicle_info")
        .html(selected_vehicle_info)
        .addClass("product-single__title");
    }
  }
});

$(document).ready(function () {
  const year = $("#dropdown-field_1").val();
  const make = $("#dropdown-field_2").val();

  if (year && year !== "-1" && make && make !== "-1") {
    call_ss_product(); // loads products immediately on page load
  }
});
